import MessagingHelpers from "../chat/helpers";

window.collapsedState = {};

export default function DashboardUnreadsRenderer() {
  this.helpers = new MessagingHelpers();
  this.userId = parseInt(document.body.dataset.userId);

  this.refreshUnreadCount = (count) => {
    let wrapper = document.getElementById("dashboard-notification-counter");
    let searchBox = document.getElementById("unread-comment-search");

    if (count) {
      wrapper.innerHTML = `<span class="badge badge-danger ml-4">${count}</span>`;
    } else {
      wrapper.innerHTML = null;
    }
    if (searchBox) {
      searchBox.hidden = !count;
    }

    let titleText = document.title.split(") ").reverse()[0];
    if (count) {
      titleText = `(${count}) ${titleText}`;
    }

    document.title = titleText;
  };

  this.refresh = (data) => {
    if (!$("#unread-comments-container").length) {
      return;
    }

    let text = "";
    data.forEach((group) => (text += this.renderGroup(group)));
    $("#unread-comments-container").html(text);
  };

  this.refreshCounter = (length) => {
    const wrapper = document.getElementById("unread-counter");
    if (length) {
      wrapper.innerHTML = `<span class="badge badge-danger ml-2">${length}</span>`;
    } else {
      wrapper.innerHTML = null;
    }
  };

  this.renderGroup = (group) => {
    const shipmentId = group.shipment.id;

    const chatType = Object.keys(group.records)[0];

    return `
    <div class="card shadow-sm dashboard-messages-group mb-3 ${
      window.collapsedState[shipmentId] && "collapsed"
    }" data-shipment-id="${shipmentId}">
      <div class="group-actions card-header py-2 d-flex align-items-center">
        <a class="mr-4" href="/admin/shipments/${shipmentId}/${chatType}">${
      group.shipment.title
    }</a>
        <span>Owner: <a href="/admin/users/${group.shipment.owner.id}" class="owner-link">${
      group.shipment.owner.full_name
    }</a></span>
        <button class="toggle-collapse btn btn-sm btn-light ml-auto">Toggle</button>
      </div>
      ${this.renderChats(group.records, shipmentId)}
    </div>
    `;
  };

  this.renderChats = (chats, shipmentId) => {
    return Object.keys(chats)
      .map((key) => {
        const approvalsLength = chats[key].filter((x) => x.system_message_type === "approval")
          .length;

        const approvalsBlock =
          approvalsLength > 0
            ? `<span class="approval-notifications">Approval Notifications: ${approvalsLength}</span>`
            : "";

        let chatName = "Private Chat";
        switch (key) {
          case "private_chat":
            chatName = "Private Chat";
            break;
          case "public_chat":
            chatName = "Public Chat";
            break;
          case "agents_chat":
            chatName = "Agents Chat";
            break;
        }

        return `
      <div class="card-body unread-chat py-2">
        <div class="d-flex mb-1">
          <a href="/admin/shipments/${shipmentId}/${key}" class="btn btn-sm btn-outline-primary mr-2">${chatName}<span class="badge badge-danger ml-1">${
          chats[key].length
        }</span>
          </a>
          <a class="refresh btn btn-sm btn-outline-secondary ml-auto mr-2" href="/admin/chats/${
            chats[key][0].chat_id
          }/unfollow" data-remote="true" data-method="post">Unfollow</a>
          <a class="refresh btn btn-sm btn-outline-primary" href="/admin/chats/${
            chats[key][0].chat_id
          }/mark_read" data-remote="true" data-method="post">Mark this chat read</a>
        </div>
        <span>${approvalsBlock}</span>
      </div>
      <ul class="list-group list-group-flush">
        ${this.renderNotifications(chats[key], shipmentId)}
      </ul>
      `;
      })
      .join("<hr>");
  };

  this.renderNotifications = (comments, shipmentId) => {
    let text = "";
    comments.forEach((message, _i) => {
      text += this.renderNotification(message, shipmentId);
    });
    return text;
  };

  this.renderNotification = (comment, shipmentId) => {
    const saveClass = comment.saved_for_user_ids.includes(this.userId) ? "saved" : "";

    return `
      <li class="list-group-item dashboard-single-message py-2 px-3 unread align-items-start">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-baseline">
            <a class="refresh save-message ${saveClass} mr-2" href="/admin/chats/${
      comment.chat_id
    }/chat_comments/${comment.id}/toggle_save" data-remote="true" data-method="post">
              <svg class="bs" width="20px" height="20px" fill="currentColor">
                <use href="/icons/bootstrap-icons.svg#bookmark-fill" />
              </svg>
            </a>
            <a class="single-message-author text-body text-decoration-none" href="/admin/shipments/${shipmentId}/chats/${
      comment.chat_id
    }">
              <b class="mr-1">${comment.author.full_name} | ${comment.author.organization_name}</b>
              <small class="text-nowrap">${comment.human_time} ago</small>
            </a>
          </div>
          <a class="d-block m-2 text-body text-decoration-none" href="/admin/shipments/${shipmentId}/chats/${
      comment.chat_id
    }">
            ${this.helpers.safeHtml(comment.content)}
          </a>
        </div>
        <a class="refresh ml-auto mt-2 btn btn-sm btn-light" href="/admin/chats/${
          comment.chat_id
        }/chat_comments/${comment.id}/mark_read" data-remote="true" data-method="post">Read
        </a>
      </li>
    `;
  };
}
